import { RichTextarea, RichTextareaProps } from "rich-textarea";

export default function TextArea(props: Omit<RichTextareaProps, "ref">) {
  return <RichTextarea {...props} />;
}
